const CutoutType = {
  CLASSII: 'CLASSII',
  CLASSIII: 'CLASSIII',
} as const

type CutoutType = typeof CutoutType[keyof typeof CutoutType]

export { CutoutType }
